import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { filterRequest } from "../../utilities/apiManager";
import axiosInstance from "../../utilities/axiosInstance";

let initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
}

export const getDeduction = createAsyncThunk(
  "deduction/getDeduction",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, query } = args;
      const filter = filterRequest(args.filter);
      const { data } = await axiosInstance.get(
        `/deduction?page=${page}&size=${size}&query=${query}${filter}`
      );
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const createDeduction = createAsyncThunk(
  "deduction/createDeduction",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(
        `/deduction`,
        args
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const updateDeduction = createAsyncThunk(
  "deduction/updateDeduction",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.put(
        `/deduction/${args._id}`,
        args
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const deleteDeduction = createAsyncThunk(
  "deduction/deleteDeduction",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.delete(
        `/deduction/${args._id}`
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const deductionSlice = createSlice({
  name: "deduction",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getDeduction.pending, (state) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(getDeduction.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.error = null;
        state.data = payload.data;
        state.itemsCount = payload.itemsCount;
        state.pages = payload.pages;
      })
      .addCase(getDeduction.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(createDeduction.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createDeduction.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data.push(payload.data);
        state.itemsCount++;
        state.error = null;
      })
      .addCase(createDeduction.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(updateDeduction.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateDeduction.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        const indexAt = state.data.findIndex(el => el._id === payload.data._id);
        state.data[indexAt] = payload.data;
        state.error = null;
      })
      .addCase(updateDeduction.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(deleteDeduction.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteDeduction.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = state.data.filter(el => el._id !== payload.data._id);
        state.error = null;
      })
      .addCase(deleteDeduction.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })
  }
});

export default deductionSlice.reducer;